module.exports = __webpack_public_path__ + "img/6.fbe6a545.png";